import { render, staticRenderFns } from "./X-chargee-Modale-livraison.vue?vue&type=template&id=6f92958a"
import script from "./X-chargee-Modale-livraison.vue?vue&type=script&lang=js"
export * from "./X-chargee-Modale-livraison.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/bitnami/deploy/oscar_front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f92958a')) {
      api.createRecord('6f92958a', component.options)
    } else {
      api.reload('6f92958a', component.options)
    }
    module.hot.accept("./X-chargee-Modale-livraison.vue?vue&type=template&id=6f92958a", function () {
      api.rerender('6f92958a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/livraison/X-chargee-Modale-livraison.vue"
export default component.exports